<template>
  <div>
    <div class="profilePic-container" @click="selectImage">
      <div class="floating front">
        <img v-if="image" :src="image" @error="handleError" />
      </div>
      <div class="floating back">
        <i class="fas fa-user" ></i>
      </div>
      <!-- <div class="blackout">
        <span>
          {{ $t('dashboard.change_profilepic.title') }}
        </span>
      </div> -->
    </div>
    <!-- <ChangeProfilePicModal 
      v-if="openModal"
      @close="closeModal"
      @updateProfilePic="updateProfilePic"
    /> -->
  </div>
</template>

<script>
import FontAwesome from "../../../public/js/lib/FontAwesomeKit"; // <--- importing FontAwesome icons
import eventbus from "../../eventbus";
import resources from "../../resources";
import ChangeProfilePicModal from "../Modal/ChangeProfilePic.vue";

import Cache from "../../modules/Cache";
import ThemeManager from "../../modules/ThemeManager/ThemeManager";

export default {
  components: {
    ChangeProfilePicModal,
  },
  data() {
    return {
      openModal: false,
      image: null,
    };
  },
  mounted() {
    // const cachedImage = Cache.getUserProfilePic();
    const user = this.$auth.user();
    this.image = ThemeManager.parseWebstarDefaultsImageUrl(user.profile_pic);

    // if (cachedImage) {
    //   this.image = cachedImage;
    // } else if (user.profile_pic) {
    //   this.image = resources.user.getProfilePicURL(user.profile_pic);
    // }
  },
  methods: {
    selectImage() {
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },
    updateProfilePic(newProfilePic) {
      this.image = ThemeManager.parseWebstarDefaultsImageUrl(newProfilePic);
      eventbus.updateProfile({
        profile_pic: this.image
      });
    },
    handleError() {
      this.image = null;
      // Cache.deleteUserProfilePic();
    },
  },
  watch: {
    "$store.state.general.site_type": function() {
      this.image = ThemeManager.parseWebstarDefaultsImageUrl(this.image);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";


.profilePic-container {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #fff;
  margin: 0 auto;
  margin-bottom: 20px;
  // border: 1px solid var(--pallete_main_color);
  border: 1px solid var(--pallete_dark_text_color);
  display: flex;

  .floating {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    &.front {
      z-index: 10;
    }

    &.back {
      z-index: 5;
    }
  }

  i {
    margin: auto;
    font-size: 100px;
    // color: var(--pallete_main_color);
    color: var(--pallete_dark_text_color);
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  // cursor: pointer;
  position: relative;

  .blackout {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: rgba(0,0,0,0.5);
    display: none;
    z-index: 99;

    span {
      color: var(--pallete_clear_color);
      text-align: center;
      vertical-align: middle;
      margin: auto;
    
      &::selection {
        background-color: transparent;
      }
    }
  }

  &:hover {
    .blackout {
      display: flex;
    }
  }
}

#profilePic {
  visibility: hidden;
}
</style>
